/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const LockClosedOutlineIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.79501C9.37665 1.79501 7.25 3.92166 7.25 6.54501V9H6C4.89543 9 4 9.89543 4 11V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V11C20 9.89543 19.1046 9 18 9H16.75V6.54501C16.75 3.92166 14.6234 1.79501 12 1.79501ZM15.25 9V6.54501C15.25 4.75009 13.7949 3.29501 12 3.29501C10.2051 3.29501 8.75 4.75009 8.75 6.54501V9H15.25ZM18.5 11C18.5 10.7239 18.2761 10.5 18 10.5H6C5.72386 10.5 5.5 10.7239 5.5 11V20C5.5 20.2761 5.72386 20.5 6 20.5H18C18.2761 20.5 18.5 20.2761 18.5 20V11ZM13.5 15.5C13.5 16.3284 12.8284 17 12 17C11.1716 17 10.5 16.3284 10.5 15.5C10.5 14.6716 11.1716 14 12 14C12.8284 14 13.5 14.6716 13.5 15.5Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
